// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-select-dropdown__item.selected[data-v-bcf16946]{font-weight:400;color:#606266}.re[data-v-bcf16946]{margin-left:20px;color:#f60;cursor:pointer;font-size:20px;background:#fff;border-radius:50%}", ""]);
// Exports
module.exports = exports;
